import createIcon from '../../createIcon';

/**
 * @component @name EmojiEmotions
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEuOTkgMkM2LjQ3IDIgMiA2LjQ4IDIgMTJDMiAxNy41MiA2LjQ3IDIyIDExLjk5IDIyQzE3LjUyIDIyIDIyIDE3LjUyIDIyIDEyQzIyIDYuNDggMTcuNTIgMiAxMS45OSAyWk04LjUgOEM5LjMzIDggMTAgOC42NyAxMCA5LjVDMTAgMTAuMzMgOS4zMyAxMSA4LjUgMTFDNy42NyAxMSA3IDEwLjMzIDcgOS41QzcgOC42NyA3LjY3IDggOC41IDhaTTEyIDE4QzkuNzIgMTggNy43OCAxNi4zNCA3IDE0SDE3QzE2LjIyIDE2LjM0IDE0LjI4IDE4IDEyIDE4Wk0xNS41IDExQzE0LjY3IDExIDE0IDEwLjMzIDE0IDkuNUMxNCA4LjY3IDE0LjY3IDggMTUuNSA4QzE2LjMzIDggMTcgOC42NyAxNyA5LjVDMTcgMTAuMzMgMTYuMzMgMTEgMTUuNSAxMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const EmojiEmotions = createIcon('EmojiEmotions', [
  [
    'path',
    {
      d: 'M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM8.5 8C9.33 8 10 8.67 10 9.5C10 10.33 9.33 11 8.5 11C7.67 11 7 10.33 7 9.5C7 8.67 7.67 8 8.5 8ZM12 18C9.72 18 7.78 16.34 7 14H17C16.22 16.34 14.28 18 12 18ZM15.5 11C14.67 11 14 10.33 14 9.5C14 8.67 14.67 8 15.5 8C16.33 8 17 8.67 17 9.5C17 10.33 16.33 11 15.5 11Z',
      key: '8kuuxl',
    },
  ],
]);

export default EmojiEmotions;
